export default {
  lang: "Português",

  // Dextra Content
  welcome: "Consulta de vídeo Dextra",
  s_services: "Serviços Dextra",
  s_tracking: "Rastreamento de serviços",
  s_record: "Serviços de documentos",
  s_redirect: "Redirecionamento de serviço",
  s_adress: "Serviços de endereço",
  s_feedback: "Suporte ao cliente",
  privacy: "Sua privacidade é importante. As conversas são tratadas confidencialmente e não são gravadas.",
  agentAvailability: "Disponibilidade do agente",
  available: "Disponível",
  unavailable: "Indisponível",
  connecting_title: "Conectando...",
  connecting_message: "Por favor aguarde um momento.",
  cancel: "Cancelar",
  button_start: "Começar aqui"
}
